(function () {
  function initHeader() {
    var body = document.body;
    var header = document.getElementById('mxHeader');
    var openMenu = document.getElementById('mxOpenMenu');
    var closeMenu = document.getElementById('mxCloseMenu');
    var overlay = document.getElementById('mxOverlay');
    var backTop = document.getElementById('mxBackTop');

    function showMenu() { body.classList.add('mx-menu-open'); }
    function hideMenu() { body.classList.remove('mx-menu-open'); }

    if (openMenu && !openMenu.dataset.mxBound) {
      openMenu.addEventListener('click', showMenu);
      openMenu.dataset.mxBound = 'true';
    }
    if (closeMenu && !closeMenu.dataset.mxBound) {
      closeMenu.addEventListener('click', hideMenu);
      closeMenu.dataset.mxBound = 'true';
    }
    if (overlay && !overlay.dataset.mxBound) {
      overlay.addEventListener('click', hideMenu);
      overlay.dataset.mxBound = 'true';
    }
    if (!document.documentElement.dataset.mxEscBound) {
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') hideMenu();
      });
      document.documentElement.dataset.mxEscBound = 'true';
    }

    var lastScrolled = null;
    var lastBackTop = null;
    function applyScrollState() {
      var y = window.scrollY || window.pageYOffset || 0;
      var scrolled = y > 20;
      var showBackTop = y > 500;
      if (header && scrolled !== lastScrolled) {
        header.classList.toggle('is-scrolled', scrolled);
        lastScrolled = scrolled;
      }
      if (backTop && showBackTop !== lastBackTop) {
        backTop.classList.toggle('show', showBackTop);
        lastBackTop = showBackTop;
      }
    }
    function onScroll() {
      if (window.mxHomeScrollFrame) return;
      window.mxHomeScrollFrame = window.requestAnimationFrame(function () {
        window.mxHomeScrollFrame = null;
        applyScrollState();
      });
    }
    if (!document.documentElement.dataset.mxScrollBound) {
      window.addEventListener('scroll', onScroll, { passive: true });
      document.documentElement.dataset.mxScrollBound = 'true';
    }
    applyScrollState();

    if (backTop && !backTop.dataset.mxBound) {
      backTop.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
      backTop.dataset.mxBound = 'true';
    }
  }

  function initReveal(root) {
    var revealItems = root.querySelectorAll('.reveal, .reveal-left, .reveal-right');
    if (!revealItems.length) return;
    if (!('IntersectionObserver' in window)) {
      revealItems.forEach(function (item) { item.classList.add('show'); });
      return;
    }
    if (!window.mxRevealObserver) {
      window.mxRevealObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('show');
          observer.unobserve(entry.target);
          entry.target.dataset.mxRevealDone = 'true';
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
    }
    revealItems.forEach(function (item) {
      if (item.dataset.mxRevealDone) {
        item.classList.add('show');
        return;
      }
      if (!item.dataset.mxRevealBound) {
        window.mxRevealObserver.observe(item);
        item.dataset.mxRevealBound = 'true';
      }
    });
  }

  function initFAQ(root) {
    root.querySelectorAll('.mx-faq-q').forEach(function (button) {
      if (button.dataset.mxBound) return;
      button.addEventListener('click', function () {
        var item = button.closest('.mx-faq-item');
        if (item) item.classList.toggle('open');
      });
      button.dataset.mxBound = 'true';
    });
  }

  function initReviews(root) {
    var track = root.querySelector('#mxReviewTrack');
    if (!track || track.dataset.mxBound) return;
    var nextReview = root.querySelector('#mxNextReview');
    var prevReview = root.querySelector('#mxPrevReview');
    var reviewIndex = 0;

    function maxIndex() {
      return window.innerWidth < 641 ? 3 : window.innerWidth < 1181 ? 2 : 1;
    }
    function updateReviewSlider() {
      var firstCard = track.querySelector('.mx-review-card');
      if (!firstCard) return;
      var gap = 18;
      var move = (firstCard.offsetWidth + gap) * reviewIndex;
      track.style.transform = 'translateX(-' + move + 'px)';
    }
    if (nextReview) {
      nextReview.addEventListener('click', function () {
        var max = maxIndex();
        reviewIndex = reviewIndex >= max ? 0 : reviewIndex + 1;
        updateReviewSlider();
      });
    }
    if (prevReview) {
      prevReview.addEventListener('click', function () {
        var max = maxIndex();
        reviewIndex = reviewIndex <= 0 ? max : reviewIndex - 1;
        updateReviewSlider();
      });
    }
    window.addEventListener('resize', function () {
      reviewIndex = 0;
      updateReviewSlider();
    });
    track.dataset.mxBound = 'true';
  }

  function initTilt(root) {
    // v29: keep card hover light. The old mousemove tilt ran on every pointer move
    // and made long homepage scrolling feel heavier on lower-power devices.
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    root.querySelectorAll('.tilt-card').forEach(function (card) {
      if (card.dataset.mxTiltBound) return;
      card.addEventListener('mouseenter', function () {
        card.style.willChange = 'transform';
      }, { passive: true });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
        card.style.willChange = '';
      }, { passive: true });
      card.dataset.mxTiltBound = 'true';
    });
  }



  function initCleanSearchBehavior(root) {
    root = root || document;
    var searchForms = root.querySelectorAll('.mx-header-search-form, .mx-mobile-search');
    if (!searchForms.length && root !== document) return;

    function closeHeaderMega() {
      document.querySelectorAll('m-header').forEach(function (header) {
        header.classList.remove('m-mega-active', 'slide-from-right', 'slide-reveal');
        header.classList.add('mx-search-active');
      });
      document.querySelectorAll('.m-menu__item--active').forEach(function (item) {
        item.classList.remove('m-menu__item--active');
      });
      window.clearTimeout(window.mxSearchActiveTimer);
      window.mxSearchActiveTimer = window.setTimeout(function () {
        var active = document.activeElement;
        if (!active || (!active.classList.contains('mx-header-search-input') && !active.classList.contains('mx-mobile-search-input'))) {
          document.querySelectorAll('m-header').forEach(function (header) {
            header.classList.remove('mx-search-active');
          });
        }
      }, 300);
    }

    function bindForm(form) {
      if (!form || form.dataset.mxCleanSearchBound) return;
      var input = form.querySelector('input[name="q"]');
      if (!input) return;

      form.addEventListener('mouseenter', closeHeaderMega);
      form.addEventListener('mousedown', closeHeaderMega, true);
      form.addEventListener('click', closeHeaderMega, true);
      form.addEventListener('focusin', closeHeaderMega);
      form.addEventListener('focusout', function () {
        window.clearTimeout(window.mxSearchActiveTimer);
        window.mxSearchActiveTimer = window.setTimeout(function () {
          document.querySelectorAll('m-header').forEach(function (header) {
            header.classList.remove('mx-search-active');
          });
        }, 220);
      });
      form.addEventListener('submit', function (event) {
        input.value = (input.value || '').trim();
        if (!input.value) {
          event.preventDefault();
          input.focus();
          closeHeaderMega();
          return false;
        }
        if (!form.querySelector('input[name="type"]')) {
          var hiddenType = document.createElement('input');
          hiddenType.type = 'hidden';
          hiddenType.name = 'type';
          hiddenType.value = 'product';
          form.appendChild(hiddenType);
        }
      });
      form.dataset.mxCleanSearchBound = 'true';
    }

    searchForms.forEach(bindForm);

    if (!document.documentElement.dataset.mxMegaSearchGuard) {
      document.addEventListener('mouseenter', function (event) {
        var active = document.activeElement;
        if (!active || (!active.classList.contains('mx-header-search-input') && !active.classList.contains('mx-mobile-search-input'))) return;
        if (event.target && event.target.closest && event.target.closest('.m-menu__item--mega')) closeHeaderMega();
      }, true);
      document.documentElement.dataset.mxMegaSearchGuard = 'true';
    }
  }


  function initPayBank(root) {
    root = root || document;
    root.querySelectorAll('.mx-pay-bank-card').forEach(function (card) {
      if (card.dataset.mxPayBankBound) return;
      var chips = card.querySelectorAll('.mx-bank-chip');
      var selected = card.querySelector('.mx-selected-bank-name');
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          chips.forEach(function (item) { item.classList.remove('active'); });
          chip.classList.add('active');
          if (selected) selected.textContent = chip.getAttribute('data-bank') || chip.textContent.trim();
        });
      });
      card.dataset.mxPayBankBound = 'true';
    });
  }


  function initHeroJudgemeReviews(root) {
    root = root || document;
    var strips = root.querySelectorAll('[data-mx-review-strip][data-review-source="judgeme_all_reviews"]');
    if (!strips.length) return;

    function cleanNumber(value) {
      value = String(value || '').replace(/,/g, '').trim();
      if (!value || value === '0' || value === '0.0') return '';
      var match = value.match(/\d+(?:\.\d+)?/);
      return match ? match[0] : '';
    }

    function formatCount(value) {
      var raw = String(value || '').replace(/,/g, '').trim();
      if (!raw) return '';
      var num = parseInt(raw, 10);
      if (isNaN(num) || num <= 0) return '';
      try { return num.toLocaleString(); } catch (e) { return String(num); }
    }

    function findJudgemeValues(strip) {
      var rating = cleanNumber(strip.getAttribute('data-jdgm-rating'));
      var count = cleanNumber(strip.getAttribute('data-jdgm-count'));
      var sources = document.querySelectorAll('.jdgm-all-reviews-text__text, .jdgm-carousel-number-of-reviews, [data-number-of-reviews], [data-score].jdgm-all-reviews-rating');

      sources.forEach(function (source) {
        if (!rating) {
          var score = cleanNumber(source.getAttribute('data-score'));
          if (score) rating = score;
        }
        if (!count) {
          var dataCount = cleanNumber(source.getAttribute('data-number-of-reviews'));
          if (dataCount) count = dataCount;
        }

        var text = (source.textContent || '').replace(/\s+/g, ' ').trim();
        if (!rating && text) {
          var ratingMatch = text.match(/(\d+(?:\.\d+)?)\s*(?:\/\s*5|out\s+of\s+5|stars?)/i);
          if (ratingMatch && ratingMatch[1]) rating = cleanNumber(ratingMatch[1]);
        }
        if (!count && text) {
          var countMatch = text.match(/(?:based\s+on|from)\s+([\d,]+)\s+(?:verified\s+)?reviews?/i) || text.match(/([\d,]+)\s+(?:verified\s+)?reviews?/i);
          if (countMatch && countMatch[1]) count = cleanNumber(countMatch[1]);
        }
      });

      return { rating: rating, count: count };
    }

    function applyValues(strip) {
      var values = findJudgemeValues(strip);
      var rating = values.rating || cleanNumber(strip.getAttribute('data-fallback-rating')) || '4.9';
      var count = formatCount(values.count || strip.getAttribute('data-fallback-count')) || '83';
      var label = strip.getAttribute('data-fallback-label') || 'verified reviews';
      var ratingTarget = strip.querySelector('.mx-hero-rating-value');
      var countTarget = strip.querySelector('.mx-hero-count-value');
      var labelTarget = strip.querySelector('.mx-hero-label-value');

      if (ratingTarget && ratingTarget.textContent !== rating) ratingTarget.textContent = rating;
      if (countTarget && countTarget.textContent !== count) countTarget.textContent = count;
      if (labelTarget && labelTarget.textContent !== label) labelTarget.textContent = label;
      strip.setAttribute('aria-label', rating + ' out of 5 based on ' + count + ' ' + label);
    }

    strips.forEach(function (strip) {
      applyValues(strip);
      if (strip.dataset.mxJdgmReviewBound) return;
      strip.dataset.mxJdgmReviewBound = 'true';

      [250, 800, 1600, 3200, 5200].forEach(function (delay) {
        window.setTimeout(function () { applyValues(strip); }, delay);
      });
    });

    if (!document.documentElement.dataset.mxJdgmReviewObserver) {
      var observerTarget = document.body || document.documentElement;
      if (observerTarget && 'MutationObserver' in window) {
        var observerTimer = null;
        var observer = new MutationObserver(function () {
          window.clearTimeout(observerTimer);
          observerTimer = window.setTimeout(function () {
            document.querySelectorAll('[data-mx-review-strip][data-review-source="judgeme_all_reviews"]').forEach(applyValues);
          }, 180);
        });
        observer.observe(observerTarget, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-score', 'data-number-of-reviews'] });
      }
      document.documentElement.dataset.mxJdgmReviewObserver = 'true';
    }
  }


  function initJudgemeHomeNavigation(root) {
    root = root || document;
    root.querySelectorAll('[data-mx-judgeme-home-reviews]').forEach(function (section) {
      if (section.dataset.mxJdgmHomeNavBound) return;
      var prev = section.querySelector('[data-mx-jdgm-prev]');
      var next = section.querySelector('[data-mx-jdgm-next]');
      if (!prev || !next) return;

      function findInternalArrow(direction) {
        var selectors = direction === 'prev'
          ? ['.jdgm-carousel__left-arrow', '.jdgm-carousel__prev-arrow', '.jdgm-carousel__arrow-left', '.jdgm-prev']
          : ['.jdgm-carousel__right-arrow', '.jdgm-carousel__next-arrow', '.jdgm-carousel__arrow-right', '.jdgm-next'];
        for (var i = 0; i < selectors.length; i++) {
          var arrow = section.querySelector(selectors[i]);
          if (arrow) return arrow;
        }
        return null;
      }

      function fallbackScroll(direction) {
        var scroller = section.querySelector('.jdgm-carousel__item-wrapper') || section.querySelector('.jdgm-carousel');
        if (!scroller || !scroller.scrollBy) return;
        var distance = Math.max(260, Math.round(scroller.clientWidth * 0.78));
        scroller.scrollBy({ left: direction === 'next' ? distance : -distance, behavior: 'smooth' });
      }

      function move(direction) {
        var arrow = findInternalArrow(direction);
        if (arrow) {
          arrow.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          return;
        }
        fallbackScroll(direction);
      }

      prev.addEventListener('click', function () { move('prev'); });
      next.addEventListener('click', function () { move('next'); });
      section.dataset.mxJdgmHomeNavBound = 'true';
    });
  }



  function moveJudgemeReviewerNameInsideCard(root) {
    root = root || document;
    root.querySelectorAll('[data-mx-judgeme-home-reviews] .jdgm-carousel-item').forEach(function (item) {
      var review = item.querySelector('.jdgm-carousel-item__review');
      var nameWrapper = item.querySelector('.jdgm-carousel-item__reviewer-name-wrapper');
      if (!review || !nameWrapper) return;
      if (nameWrapper.parentNode !== review) {
        var rating = review.querySelector('.jdgm-carousel-item__review-rating');
        if (rating) {
          review.insertBefore(nameWrapper, rating);
        } else {
          review.insertBefore(nameWrapper, review.firstChild);
        }
      }
      item.dataset.mxReviewerNameMoved = 'true';
    });
  }

  function initJudgemeReviewerNameObserver(root) {
    root = root || document;
    moveJudgemeReviewerNameInsideCard(root);
    if (document.documentElement.dataset.mxJdgmNameObserver) return;
    var target = document.body || document.documentElement;
    if (target && 'MutationObserver' in window) {
      var timer = null;
      var observer = new MutationObserver(function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          moveJudgemeReviewerNameInsideCard(document);
        }, 120);
      });
      observer.observe(target, { childList: true, subtree: true });
    }
    [400, 1000, 2200, 4200].forEach(function (delay) {
      window.setTimeout(function () { moveJudgemeReviewerNameInsideCard(document); }, delay);
    });
    document.documentElement.dataset.mxJdgmNameObserver = 'true';
  }

  function initAll(root) {
    root = root || document;
    initHeader();
    initReveal(root);
    initFAQ(root);
    initReviews(root);
    initTilt(root);
    initCleanSearchBehavior(root);
    initPayBank(root);
    initHeroJudgemeReviews(root);
    initJudgemeHomeNavigation(root);
    initJudgemeReviewerNameObserver(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });
})();
